/**
 * Created by hp on 2017/5/24.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Dialog} from 'react-weui';
import {getTimestamp} from '../../utils'

import '../../styles/common.css';
import '../../styles/classroom/ClassroomRedpackPanel.css';

class ClassroomRedpackPanel extends Component {
    constructor() {
        super();
        this.onHideRedpack = this.onHideRedpack.bind(this);
        this.onRedpackNumberChange = this.onRedpackNumberChange.bind(this);
        this.onRedpackMoneyChange = this.onRedpackMoneyChange.bind(this);
        this.onRedpackContentChange = this.onRedpackContentChange.bind(this);
        this.onPayRedpack = this.onPayRedpack.bind(this);
    }

    state = {
        showTipDialog: false,
        tipContent: '',
        redpackNumber: '',
        redpackMoney: '',
        redpackContent: '',
        style: {
            buttons: [
                {
                    label: '关闭',
                    onClick: this.onHideTipDialog.bind(this)
                }
            ]
        }
    };

    onHideTipDialog() {
        this.setState({showTipDialog: false});
    }

    onHideRedpack() {
        this.props.dispatch({
            type: 'HIDE_REDPACK_PANEL'
        });
    }

    onPayRedpack() {
        let {lecture} = this.props;
        let {redpackNumber, redpackMoney, redpackContent} = this.state;

        if (redpackNumber.trim() === '') {
            return this.setState({showTipDialog: true, tipContent: '红包数量没有填写'});
        }

        if (redpackMoney.trim() === '') {
            return this.setState({showTipDialog: true, tipContent: '红包金额没有填写'});
        }

        if (!redpackNumber.match(/^[0-9]*$/)) {
            return this.setState({showTipDialog: true, tipContent: '红包数量不是正整数'});
        }

        const {timestampDelta} = this.props
        let timestamp = getTimestamp(timestampDelta)

        this.props.dispatch({
            type: 'PAY_REDPACK',
            payload: {
                params: {
                    product: 'redpack',
                    count: redpackNumber,
                    description: redpackContent,
                    fee: redpackMoney * 100,
                    lecture_id: lecture.id,
                    ts: timestamp,
                },
                success: () => {
                    this.onHideRedpack()
                }
            }
        })
    }

    onRedpackContentChange(e) {
        let redpackContent = e.target.value;
        this.setState({redpackContent: redpackContent});
    }

    onRedpackNumberChange(e) {
        let redpackNumber = e.target.value;
        this.setState({redpackNumber: redpackNumber});
    }

    onRedpackMoneyChange(e) {
        let redpackMoney = e.target.value;
        this.setState({redpackMoney: redpackMoney});
    }

    render() {
        let {redpackNumber, redpackMoney, showTipDialog, tipContent, style} = this.state;
        let {showRedpackPanel} = this.props;
        if (!showRedpackPanel) {
            return null;
        }
        return (
            <div className="redpack-panel">
                <Dialog buttons={style.buttons} show={showTipDialog}>{tipContent}</Dialog>
                <div className="nav-bar-redpack">
                    <p>拼手气红包
                        <a className="redpack-close" onClick={this.onHideRedpack}>关闭</a>
                    </p>
                </div>
                <div className="weui-padding">
                    <div className="weui-flex input-box" style={{padding: "0 15px"}}>
                        <p className="weui-flex__item flex_3 text-left">红包个数</p>
                        <div className="weui-flex__item flex_6">
                            <input className="text-right" placeholder="填写个数" pattern="[0-9]*"
                                   value={redpackNumber} max="100" min="1"
                                   onChange={this.onRedpackNumberChange}/>
                        </div>
                        <p className="weui-flex__item flex_1 text-right">个</p>
                    </div>
                    <p className="weui-padding text-minor text-left">最多100个</p>

                    <div className="weui-flex input-box" style={{padding: "0 15px"}}>
                        <p className="weui-flex__item flex_3 text-left">总金额</p>
                        <div className="weui-flex__item flex_6">
                            <input className="text-right" placeholder="填写金额" type="number" step="0.01" value={redpackMoney}
                                   max="10000"
                                   onChange={this.onRedpackMoneyChange}/>
                        </div>
                        <p className="weui-flex__item flex_1 text-right">元</p>

                    </div>
                    <p className="weui-padding text-minor text-left">总金额上限为10000元</p>
                    <textarea placeholder="恭喜发财，大吉大利！" id="redpack_tips" onChange={this.onRedpackContentChange}/>
                    <p className="redpack-money-all">
                        ¥ <span id="redpack_money_num">{redpackMoney === "" ? 0 : redpackMoney}</span>
                    </p>
                    <a className="weui-btn weui-btn_warn" onClick={this.onPayRedpack}>塞钱进红包</a>
                    <p className="text-minor margin-top-double">未领取的红包，7天后自动转入个人收益</p>
                </div>
            </div>
        )
    }
}

ClassroomRedpackPanel.childContextTypes = {
    page: React.PropTypes.object
};

export default connect((state) => ({
    showRedpackPanel: state.classroom.showRedpackPanel,
    account: state.account,
    lecture: state.classroom.lecture,
    timestampDelta: state.classroom.timestampDelta,
}))(ClassroomRedpackPanel)


// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomRedpackPanel.js